import Rest from '../rest'
// import axios  from 'axios'

export default class ReserveQueue extends Rest {
    /**
     * @param {String} resource
     */
     constructor () {
        super('/availability/queue/reserves')
    }

    getData(id) {
        return this.getAll(id, '')
            .then((response) => {
                return response
            })
    }
}